<template>
    <div id="form-collapse-section">
        <div class="form-collapse-section">
            <h3>Bölüm Daraltma</h3>
        </div>
    </div>
</template>
<script>
export default {
    name: "form-collapse-section",
};
</script>
<style scoped lang="scss">
#form-collapse-section {

}
</style>
